import ApiClient from './ApiClient';

export default class DelegateApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getActiveUserDelegations(userId) {
    return this.apiClient.get({ path: `/api/identity/delegate/${userId}/` });
  }

  getUserDelegationsInPeriod(userId, body) {
    return this.apiClient.post({ path: `/api/identity/delegate/${userId}/`, body });
  }

  createDelegates(body) {
    return this.apiClient.post({ path: '/api/identity/delegate', body });
  }

  createDelegation(body) {
    return this.apiClient.post({ path: '/api/identity/delegate/create', body });
  }

  deleteDelegationById(delegationId) {
    return this.apiClient.del({ path: `/api/identity/delegate/${delegationId}/` });
  }
}
